const env = {
    apiUrl: "https://ppacienteqa.azurewebsites.net/api/"
}

module.exports = env;